// extracted by mini-css-extract-plugin
export default {"convers_AI_main_container":"ConversationalAIComponent_convers_AI_main_container__A1NmS"};